// CR27-21: shifts a worker can write a progress note against for one participant — including after clock-out (notes are
// often written at home). Started shifts newest first, then upcoming soonest first; cancelled shifts left out.
// Same order as the mobile app (mobile/src/screens/notes/shiftContext.ts noteShiftOptions).
const startMs = (s) => {
  const t = new Date(`${s.date || ''}T${(s.start_time || '00:00').padStart(5, '0')}`).getTime();
  return Number.isNaN(t) ? Number.MAX_SAFE_INTEGER : t;
};

export function noteShiftOptions(shifts, participantId, nowMs = Date.now()) {
  const mine = (shifts || []).filter((s) => String(s.participant_id || '') === String(participantId)
    && String(s.status || '').toUpperCase() !== 'CANCELLED');
  const started = mine.filter((s) => startMs(s) <= nowMs).sort((a, b) => startMs(b) - startMs(a));
  const upcoming = mine.filter((s) => startMs(s) > nowMs).sort((a, b) => startMs(a) - startMs(b));
  return [...started, ...upcoming];
}

/** The shift to preselect: the one in progress, else the latest started one, else none. */
export function defaultNoteShift(options, nowMs = Date.now()) {
  const running = options.find((s) => String(s.status || '').toUpperCase() === 'IN_PROGRESS' || (s.check_in_time && !s.check_out_time));
  return running || options.find((s) => startMs(s) <= nowMs) || null;
}
